<template>
  <div
    ref="root"
    class="form-group sog-form-field"
  >
    <slot />
    <div
      ref="error"
      class="error"
    />
  </div>
</template>

<script setup lang="ts">


import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";

interface Props {
  validation1?:SogFormValidationRule,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(),{validation1:undefined}
)
</script>

<style scoped>

</style>
